import React from "react";
import PropTypes from "prop-types";
import Format from "../../../helpers/Format";
import { formataData } from "../../../helpers/mesesHelper";

function DadosInvoice({ invoiceData, excluirItem, values }) {
  return (
    <>
      <div
        style={{
          fontFamily: "Arial, sans-serif",
          fontSize: "12px",
          padding: "1px",
        }}
      >
        {invoiceData?.idInvoice && (
          <div
            className="d-flex justify-content-between align-items-center,"
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            <h5>
              <b>{invoiceData?.razao}</b>
            </h5>
            <p style={{ margin: 0, fontSize: "20px" }}>
              #{invoiceData?.idInvoice}
            </p>
          </div>
        )}
        {invoiceData?.idInvoice && <hr></hr>}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          {invoiceData?.idInvoice && (
            <div style={{ textAlign: "left" }}>
              <h6 style={{ margin: "0 0 5px 0", lineHeight: "1.2" }}>
                <b>Provider</b>
              </h6>
              <p style={{ margin: "2px 0" }}>{invoiceData?.razao}</p>
              <p style={{ margin: "2px 0" }}>
                {invoiceData?.enderecoEmpresa} {invoiceData?.numeroEmpresa}{" "}
                {invoiceData?.complEmpresa}
              </p>
              <p style={{ margin: "2px 0" }}>{invoiceData?.bairroEmpresa}</p>
              <p style={{ margin: "2px 0" }}>
                {invoiceData?.cidadeEmpresa} {invoiceData?.ufEmpresa}{" "}
                {invoiceData?.cepEmpresa}
              </p>
            </div>
          )}

          <div style={{ textAlign: invoiceData?.idInvoice ? "right" : "left" }}>
            <h6 style={{ margin: "0 0 5px 0", lineHeight: "1.2" }}>
              <b>Contractor</b>
            </h6>
            <p style={{ margin: "2px 0" }}>{invoiceData?.razao_social}</p>
            <p style={{ margin: "2px 0" }}>
              {invoiceData?.logradouro} {invoiceData?.numero}{" "}
              {invoiceData?.complemento}
            </p>
            <p style={{ margin: "2px 0" }}>{invoiceData?.bairro}</p>
            <p style={{ margin: "2px 0" }}>
              {invoiceData?.cidade} {invoiceData?.uf} {invoiceData?.cep}
            </p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ textAlign: "left" }}>
            <h6 style={{ margin: "0 0 5px 0", lineHeight: "1.2" }}>
              <b>Payment</b>
            </h6>
            <p style={{ margin: "2px 0" }}>
              {values?.metodoPagamento?.join(", ")}
            </p>
            <p style={{ margin: "2px 0" }}>{invoiceData?.email}</p>
          </div>
          <div style={{ textAlign: "right", lineHeight: "1.2" }}>
            <h6 style={{ margin: "0 0 5px 0" }}>
              <b>Date</b>
            </h6>
            <p style={{ margin: "2px 0" }}>{formataData(values?.data)}</p>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "8px",
          }}
        >
          <h6>
            <b>Order summary</b>
          </h6>
        </div>
        <table
          style={{ width: "100%", borderCollapse: "collapse", height: "50px" }}
        >
          <thead>
            <tr style={{ borderBottom: "1px solid #eee", height: "50px" }}>
              <th style={{ width: "62%" }}>Item</th>
              <th style={{ width: "5%", textAlign: "center" }}>Quantity</th>
              <th style={{ width: "30%", textAlign: "end" }}>Price</th>
              <th style={{ width: "3%", textAlign: "end" }}></th>
            </tr>
          </thead>
          <tbody>
            {(invoiceData?.itens || []).map((invoice, index) => {
              return (
                <tr
                  style={{ borderBottom: "1px solid #eee", height: "50px" }}
                  key={`tr-${index}`}
                >
                  <td>{invoice.descricao}</td>
                  <td style={{ textAlign: "center" }}>{invoice.quantidade}</td>
                  <td style={{ textAlign: "end" }}>
                    {Format.formataValor(invoice.quantidade ? (invoice.valorTotal / invoice.quantidade).toFixed(2) : 0)}
                  </td>
                  <td style={{ textAlign: "end" }}>
                    {!invoiceData?.idInvoice && (
                      <i
                        className="mdi mdi-delete"
                        style={{
                          color: "red",
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          excluirItem(index);
                        }}
                      />
                    )}
                  </td>
                </tr>
              );
            })}
            <tr style={{ borderBottom: "1px solid #eee", height: "50px" }}>
              <td colSpan="2" style={{ textAlign: "end" }}>
                Sub Total
              </td>
              <td colSpan="1" style={{ textAlign: "end"}}>
                {Format.formataValor(
                  invoiceData?.itens
                    ? invoiceData.itens.reduce(
                        (total, invoice) =>
                          total + (parseFloat(invoice.valorTotal) || 0),
                        0
                      )
                    : 0
                )}
              </td>
            </tr>
            <tr style={{ borderBottom: "1px solid #eee", height: "50px" }}>
              <td colSpan="2" style={{ textAlign: "end" }}>
                <b>Discount</b>
              </td>
              <td colSpan="1" style={{ textAlign: "end" }}>
                {Format.formataValor(values?.desconto || 0)}
              </td>
            </tr>
            <tr style={{ height: "50px" }}>
              <td colSpan="2" style={{ textAlign: "end", fontSize: "15px" }}>
                <b>Total: </b>
              </td>
              <td colSpan="1" style={{ textAlign: "end", fontSize: "15px" }}>
                <b>
                  {Format.formataValor(
                    invoiceData?.itens
                      ? invoiceData.itens.reduce(
                          (total, invoice) =>
                            total + (parseFloat(invoice.valorTotal) || 0),
                          0
                        ) - (values?.desconto || 0)
                      : 0
                  )}
                </b>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

DadosInvoice.propTypes = {
  invoiceData: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  excluirItem: PropTypes.array.isRequired,
};

export default DadosInvoice;
